<div class="card px-4 pb-4">
  <h2>Select department and team</h2>

  <div class="style2023 grid">
    <div class="col-6">
      <div>Department</div>
      <div class="">
        <div class="mt-2">
          <p-dropdown
            name="departments"
            class="filter-dropdown border-validation"
            required
            [options]="departments"
            (onChange)="departmentChange($event)"
            [(ngModel)]="customerDepartmentId"
            filter="true"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div>Team</div>
      <div class="mt-2">
        <p-dropdown
          name="teams"
          class="filter-dropdown border-validation"
          required
          [options]="teams"
          [(ngModel)]="customerTeamId"
          (onChange)="teamChange($event)"
          filter="true"
        ></p-dropdown>
      </div>
    </div>
  </div>
</div>
